import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="glass rounded-xl overflow-hidden transition-all duration-300" data-id="element-125">
      <button className="w-full p-5 flex justify-between items-center text-left focus:outline-none" onClick={onClick} data-id="element-126">
        <span className="text-base font-bold text-white pr-4" data-id="element-127">{question}</span>
        <ChevronDown className={`w-5 h-5 text-white/50 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-accent' : ''}`} data-id="element-128" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-129">
        <p className="p-5 pt-0 text-white/70 leading-relaxed text-sm" data-id="element-130">
          {answer}
        </p>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Sirve para todas las razas?',
    answer: 'Sí. La biología del estrés y la regulación del cortisol funcionan igual en un Chihuahua que en un Pastor Alemán. El protocolo se adapta a la energía de tu perro.'
  }, {
    question: '¿Es un pago único?',
    answer: 'Sí, es un único pago. Sin suscripciones, sin cuotas mensuales ni cobros ocultos. Tendrás acceso de por vida al material desde cualquier dispositivo.'
  }, {
    question: '¿Cuándo veré resultados? (Spoiler: Día 3)',
    answer: 'La mayoría de dueños notan una reducción drástica de la tensión en la correa al tercer día de aplicar la técnica de "Conexión Silenciosa".'
  }];
  return <section className="py-12 px-5" data-id="element-131">
      <div className="max-w-lg mx-auto" data-id="element-132">
        <div className="flex flex-col gap-4" data-id="element-133">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-134" />)}
        </div>
      </div>
    </section>;
}